module.exports = __webpack_public_path__ + "img/car-tilt.a2a5833c.svg";